module.exports = "//img1.rrcimg.com/_next/static/src/assets/nj_3Dqkk.png";